// src/modules/app-views/invoices/pages/Document/actions/actionButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { SaveOutlined } from '@ant-design/icons';
import { isLockedStatus } from 'services/fiscalService';

// *******************************************************************************
// ACTION BUTTON
// *******************************************************************************
const invoicesDocumentActionButton = () => {
  return {
    action: 'save',
    hideButton: false,
    label: 'save',
    tooltip: 'save_document',
    icon: <SaveOutlined />,
    type: 'primary',
    // Disable save button for locked statuses (authorized, canceled, voided, denied, corrected)
    disabled: ({ page }) => isLockedStatus(page?.data?.status),
    // Use 'submit' directly from context instead of moduleContext.formContext
    // This ensures we get the correctly resolved submitForm function
    onClick: ({ submit }) => submit?.(),
    dropdownItems: [],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default invoicesDocumentActionButton;
